import { render, staticRenderFns } from "./guobu-verify.vue?vue&type=template&id=68072b99"
import script from "./guobu-verify.vue?vue&type=script&lang=js"
export * from "./guobu-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports